import styled from 'styled-components';
import { MEDIA_QUERY, SPACING } from '@optimus-web/local-tokens';

const minOpacity = '0.6';

type MaxWidth = 'small' | 'large';

const getMaxWidth = (maxWidth: MaxWidth) => {
    switch (maxWidth) {
        case 'small':
            return '640px';
        case 'large':
            return '960px';
        default:
            return 'none';
    }
};

interface ContentContainerProps {
    maxWidth?: MaxWidth;
    fill?: boolean;
    condensed?: boolean;
    disabled?: boolean;
}

export const ContentContainer = styled('div').withConfig<ContentContainerProps>({
    shouldForwardProp: (prop, defaultValidatorFn) => !['fill'].includes(prop) && defaultValidatorFn(prop),
})`
    margin: 0 auto;
    padding: ${(props) => (props.condensed ? `${SPACING[100]}px` : `${SPACING[300]}px ${SPACING[200]}px`)};
    ${(props) => props.maxWidth && `max-width: ${getMaxWidth(props.maxWidth)}`};
    position: relative;

    ${MEDIA_QUERY['from-large']} {
        padding: ${(props) => (props.condensed ? `${SPACING[200]}px` : `${SPACING[400]}px ${SPACING[300]}px`)};
    }

    ${(props) =>
        props.fill &&
        `
        height: calc(100% - ${SPACING[300] * 2}px);

        ${MEDIA_QUERY['from-large']} {
            height: calc(100% - ${SPACING[400] * 2}px);
        }
    `}
    ${(props) =>
        props.disabled &&
        `
    pointer-events: none;
    opacity: ${minOpacity};
    `};
`;

export default ContentContainer;
